export default {
    methods: {
      getDay(screeningAllowed, screeningDuration, day) {
        const sd = screeningAllowed ? screeningDuration : 0;
        return day - sd;
      }
    }
  };